import { makeStyles } from '@material-ui/core';
import { pxToRem } from '../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => ({

  CustomMenuProps: {
    borderRadius: '10px !important',
    width: 'auto',
    boxShadow: '0px 4px 32px 0px #00000040',
    maxHeight: pxToRem(552),
    '& .MuiList-root': {
      padding: `${pxToRem(32)}`,
      [theme.breakpoints.down('sm')]: {
        padding: `${pxToRem(16)}`,
      },
    }
  },

  root: {
    position: 'relative',
    height: pxToRem(423),
    width: 'calc(100% + 6.179% + 6.18%)',
    ...theme.mixins.marginLeft('-6.18%'),
    marginTop: (pxToRem(-51)),
    marginBottom: (pxToRem(40)),
    '& img': {
      display: 'block'
    },
    '&:before': {
      width: '100%',
      height: '100%',
      ...theme.mixins.left(0),
      top: 0,
      content: "''",
      zIndex: 1,
      backgroundColor: '#00000066',
      position: 'absolute'
    },
    [theme.breakpoints.down('md')]: {
      width: 'calc(100% + 48px)',
      ...theme.mixins.marginLeft(-24),
      height: pxToRem(266),
      marginBottom: (pxToRem(16)),
    },
  },

  adListingContainer: {
    zIndex: 2,
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    bottom: pxToRem(56),
    padding: '0 5.5%',
    [theme.breakpoints.down('sm')]: {
      bottom: pxToRem(32),
      padding: `0 ${pxToRem(24)}`,
    },
    '& .breadcrumbWrapper': {
      marginBottom: pxToRem(32),
      [theme.breakpoints.down('md')]: {
        marginBottom: pxToRem(8),
      },
      '& .MuiGrid-root': {
        margin: 0,
        color: "#fff",
        '& ol': {
          '& li': {
            '& a, span': {
              color: "#fff"
            }
          }
        }
      }
    }
  },


  adListingOptionsContainer: {

    outline: 'none',
    fontSize: pxToRem(72),
    lineHeight: pxToRem(80),
    color: 'white !important',
    width: 'fit-content',
    '&.MuiInput-underline': {
      '&::before': {
        borderBottom: 'none',
        transition: 'none',
      },
      '&::after': {
        borderBottom: 'none',
        transition: 'none',
      },
      '&:hover:not(.Mui-disabled)::before': {
        borderBottom: 'none',
      },
    },

    '& .MuiSelect-icon': {
      color: 'white',
    },
    '& .MuiSvgIcon-root': {
      fontSize: pxToRem(45),
      // right: '-2%',
      top: '35%',
      ...theme.mixins.right(-20),
      '[dir="rtl"] &': {
        right: 'calc(100% - 40px)'
      },

      // fontSize: pxToRem(50)
    },
    '& .MuiSelect-selectMenu': {
      textDecoration: 'underline',
      textUnderlineOffset: pxToRem(17),
      fontFamily: theme.custom.fontFamily.primaryBold,
      '[dir="rtl"] &': {
        paddingLeft: pxToRem(40),
        paddingRight: pxToRem(0)
      },
    },
    '& .MuiSelect-select': {
      '&:focus': {
        backgroundColor: 'transparent',
      },
    },



    [theme.breakpoints.down('md')]: {
      fontSize: pxToRem(32),
      lineHeight: pxToRem(40),
      '& .MuiSvgIcon-root': {
        fontSize: pxToRem(45),
        right: '-8%',
        top: 'calc(50% - 20px)',
      },
      '& .MuiSelect-selectMenu': {
        textUnderlineOffset: pxToRem(8),
      },
    },
  },



  adListingOptions: {
    fontFamily: theme.custom.fontFamily.primaryBold,
    fontSize: pxToRem(28),
    lineHeight: pxToRem(36),
    ...theme.mixins.paddingLR(0),
    paddingTop: pxToRem(0),
    paddingBottom: pxToRem(16),
    transition: "ease 0.5s all",
    color: 'black !important',
    [theme.breakpoints.down('md')]: {
      fontSize: pxToRem(20),
      lineHeight: pxToRem(32),
      paddingBottom: pxToRem(12),
    },
    '&.Mui-focusVisible': {
      outline: 'none'
    },
    '&:hover': {
      [theme.breakpoints.up('lg')]: {
        color: '#FF8707 !important',
        backgroundColor: 'transparent !important',
      },
    },
    '&.Mui-selected': {
      backgroundColor: 'transparent !important ',
      color: '#FF8707 !important',
    },
  },
  adListingSpan: {
    color: 'white !important',

    fontSize: pxToRem(72),
    lineHeight: pxToRem(80),
    [theme.breakpoints.down('md')]: {
      fontSize: pxToRem(32),
      lineHeight: pxToRem(40),
    },
  },
}))



export default useStyles;